import Strength from './Strength'

export default Strength
